import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "src/shared/api/base-query";
import { pagedQueryFn } from "src/shared/api/paged-query-fn";
import type { QuerySubscriptionOptions } from "src/shared/api/query-subscription-options";

import { ITechOperationParam } from "../shared/interfaces/tech-operation-param";

export const techOperationParamsApi = createApi({
  reducerPath: "techOperationParamsApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchTechOperationParamsWithDeleted: builder.query<ITechOperationParam[], void>({
      queryFn: pagedQueryFn<ITechOperationParam, ITechOperationParam[]>(
        { url: "TechOperationParamsV2", params: { includeDeleted: true } },
        (dtos) => dtos
      ),
    }),
  }),
});

const useTechOperationParamsEndpoint =
  techOperationParamsApi.endpoints.fetchTechOperationParamsWithDeleted.useQuery;

export function useFetchTechOperationParamsWithDeleted(
  options?: QuerySubscriptionOptions<typeof useTechOperationParamsEndpoint>
) {
  return useTechOperationParamsEndpoint(undefined, options);
}
